import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import calendar from "dayjs/plugin/calendar";
dayjs.extend(relativeTime);
dayjs.extend(calendar);

let DayjsPlugin = Object();

DayjsPlugin.install = function(Vue) {
  Vue.mixin({
    filters: {
      dayjs(date, format) {
        if (format === "calendar") return dayjs(date).calendar();
        if (format === "fromNow") return dayjs(date).fromNow();
        return dayjs(date).format(format);
      }
    },
    methods: {
      $dayjs(payload) {
        return dayjs(payload);
      }
    }
  });
};

export default DayjsPlugin;
